import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import CommercialCampaignsEvents from './CommercialCampaignsEvents';

import CommercialCampaignsDetailsSectionInfo from './details/sections/CommercialCampaignsDetailsSectionInfo';
import CommercialCampaignsDetailsSectionSecondaryInfo from './details/sections/CommercialCampaignsDetailsSectionSecondaryInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<CommercialCampaignsDetailsSectionInfo {...props} />
			<InlineTitle text="DETAILS_SECONDARY_INFO_SECTION" />
			<CommercialCampaignsDetailsSectionSecondaryInfo {...props} />
			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="cmcp_descriptionhtml"
				value={props.model.cmcp_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
		</>
	),
	events: CommercialCampaignsEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
